type Cancellable = { cancel: () => unknown };

export type LayoutExecutorRegistry<T extends Cancellable> = {
  activate: (viewInstanceId: string, executor: T) => void;
  isActive: (viewInstanceId: string, executor: T) => boolean;
  release: (viewInstanceId: string, executor: T) => void;
};

export const createLayoutExecutorRegistry = <
  T extends Cancellable,
>(): LayoutExecutorRegistry<T> => {
  const activeByViewInstanceId = new Map<string, T>();
  return {
    activate: (viewInstanceId, executor) => {
      activeByViewInstanceId.get(viewInstanceId)?.cancel();
      activeByViewInstanceId.set(viewInstanceId, executor);
    },
    isActive: (viewInstanceId, executor) =>
      activeByViewInstanceId.get(viewInstanceId) === executor,
    release: (viewInstanceId, executor) => {
      if (activeByViewInstanceId.get(viewInstanceId) === executor) {
        activeByViewInstanceId.delete(viewInstanceId);
      }
    },
  };
};
